<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 30.8V16.5h-3v14.3a4 4 0 103 0z"/><path d="M29 10.5a6.5 6.5 0 00-13 0v17.08a9.49 9.49 0 005.41 16.36 9.59 9.59 0 001.07.06A9.49 9.49 0 0029 27.58zm-2.17 28.85a6.5 6.5 0 11-8.39-9.92L19 29V10.5a3.5 3.5 0 017 0V29l.56.45a6.5 6.5 0 01.27 9.92zM33.5 10h6a1.5 1.5 0 000-3h-6a1.5 1.5 0 000 3zM39.5 21h-6a1.5 1.5 0 000 3h6a1.5 1.5 0 000-3zM39.5 14h-6a1.5 1.5 0 000 3h6a1.5 1.5 0 000-3z"/></svg>